module.exports = __webpack_public_path__ + "static/media/superficie-gioco-gabbia-calcetto-noleggiocampi.24e56f57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/strutture/campi/calcetto/slider4/superficie/superficie-gioco-gabbia-calcetto-noleggiocampi.jpg
// module id = 647
// module chunks = 0